import * as loan from "./loan";
import * as reimbursementTask from "./reimbursement-task";
import * as loanTask from './loan-task'
import * as purchaseManage from './purchase-manage'
import * as payManage from './pay-manage'
import * as warehouseMange from './warehouse-manage'
import * as saleReimbursement from './sale-reimbursement'
import * as redSaleReimbursement from './red-sale-reimbursement'
import * as redSaleReceiptManage from './red-sale-receipt-manage'
import * as redPurchase from './red-purchase'
import * as redPay from './red-pay'
import * as assetMange from './asset-mange'
import * as JobSalary from './job-salary'
import * as laborRemuneration from './labor-remuneration'
import * as wages from './wages'
import * as repayMentDetails from './repay-ment'
export default [
    loan, reimbursementTask, loanTask, purchaseManage, payManage, saleReimbursement, warehouseMange, redPurchase, redPay, assetMange, redSaleReimbursement, redSaleReceiptManage, JobSalary, laborRemuneration, wages, repayMentDetails]



// WEBPACK FOOTER //
// ./src/store/modules/billing-center/index.js